import { StyleSheet } from 'react-native'

const styles = StyleSheet.create({
  container: {
    flex: 1
  },
  mapContainer: {
    position: 'absolute'
  },
  navigationTopbar: {
    marginHorizontal: 20
  },
  loadingContainer: {
    height: '100%',
    margin: 0,
    zIndex: 1
  }
})

export default styles
